(function () {
  if (window.promixProductContentSectionsReady) return;
  window.promixProductContentSectionsReady = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-product-content-cta]');
    if (!trigger) return;

    var product = document.querySelector('#singleProduct');
    var addButton = product && product.querySelector('.addToCartButton.add_to_cart:not([disabled])');

    if (addButton) {
      addButton.click();
      return;
    }

    if (product) {
      product.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-product-social-card]');
    if (!card || !card.dataset.videoUrl) return;

    var activeVideo = card.querySelector('video');
    document.querySelectorAll('[data-product-social-card] video').forEach(function (video) {
      if (video !== activeVideo) {
        video.pause();
        video.closest('[data-product-social-card]').classList.remove('is-playing');
      }
    });

    if (!activeVideo) {
      activeVideo = document.createElement('video');
      activeVideo.src = card.dataset.videoUrl;
      activeVideo.playsInline = true;
      activeVideo.loop = true;
      activeVideo.preload = 'metadata';
      activeVideo.controls = false;
      var poster = card.querySelector('.pc-social__poster');
      if (poster) poster.remove();
      card.appendChild(activeVideo);
    }

    if (activeVideo.paused) {
      var playRequest = activeVideo.play();
      if (playRequest && typeof playRequest.catch === 'function') {
        playRequest.catch(function () {});
      }
      card.classList.add('is-playing');
    } else {
      activeVideo.pause();
      card.classList.remove('is-playing');
    }
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-product-accordion-toggle]');
    if (!toggle) return;

    var item = toggle.closest('[data-product-accordion-item]');
    var panel = item && item.querySelector('[data-product-accordion-panel]');
    if (!item || !panel) return;

    var section = item.closest('.pc-science');
    if (!section || item.classList.contains('is-open')) return;

    section.querySelectorAll('[data-product-accordion-item]').forEach(function (candidate) {
      var candidateToggle = candidate.querySelector('[data-product-accordion-toggle]');
      var candidatePanel = candidate.querySelector('[data-product-accordion-panel]');
      candidate.classList.toggle('is-open', candidate === item);
      if (candidateToggle) candidateToggle.setAttribute('aria-expanded', candidate === item ? 'true' : 'false');
      if (candidatePanel) candidatePanel.hidden = candidate !== item;
    });

    // Swap both breakpoints' media — the desktop and mobile <img> are separate
    // elements, and leaving one behind reads as a bug on whichever is visible.
    if (toggle.dataset.imageUrl) {
      section.querySelectorAll('.pc-science__image').forEach(function (image) {
        image.src = toggle.dataset.imageUrl;
        image.srcset = toggle.dataset.imageUrl;
        image.alt = toggle.dataset.imageAlt || '';
      });
    }
  });
})();
